import React, { useState } from 'react';
import { LOGOSdi } from 'src/assets/image';
import { MenuGlobal, MobileMenuGlobal } from 'src/components';
// import MenuHome from './MenuHome';

export const HeaderHome = () => {
    const [show, setShow] = useState(false);
    const toggle = () => setShow(!show);
    return (
        <header id="masthead" className="header ttm-header-style-03">
            {/* ttm-topbar-wrapper */}
            <div className="ttm-header-wrap">
                <div className="site-header-menu">
                    <div id="navbar" className="ttm-stickable-header clearfix">
                        <div className="container-xl">
                            <div className="d-xl-flex flex-xl-row align-items-xl-center justify-content-xl-between">
                                <div className="site-branding">
                                    <a className="home-link" href={process.env.PUBLIC_URL + '/'} title="Altech" rel="home">
                                        <img id="logo-img" className="img-fluid" alt="logo" src={LOGOSdi} />
                                    </a>
                                </div>
                                <div className="site-navigation">
                                    <div className="container-xl">
                                        <div className="row align-items-center ml-auto">
                                            <div className="ml-auto">
                                                <MenuGlobal color="#fff" />
                                                <div className="mobilemenu"><MobileMenuGlobal /></div>
                                            </div>
                                            <div className="ttm-right-header ml-auto">
                                                <ul className="ttm-header-icons">
                                                </ul>
                                            </div>
                                            <div className="ml-auto right-btn"><a href="https://admin.satudata.mubakab.go.id/#/login" target="_blank" className="ml-4 ttm-btn ttm-btn-size-xs btn btn-warning ttm-textcolor-white"><i className="fa fa-user" /> Masuk</a></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    )
}

export default HeaderHome;